import {SHOW_MODAL} from '../../constants';
import { withType } from '../../../utils/actionOperations';
export function showModal(params) {
    return dispatch => {
        dispatch(withType(SHOW_MODAL, {}));
    };
}
